import Logger from 'utils/logger';
import { getLocalIp } from 'utils/ipHelper';
import { parseAttachmentFileName } from 'utils/fileHelper';

export async function requestGet(url) {
  const option = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      'X-Auth-Local-Address': getLocalIp()
    }
  };
  return executeFetch(url, option);
}

export async function requestPost(url, body) {
  body = JSON.stringify(body);
  const option = {
    method: 'POST',
    body,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      'content-Type': 'application/json;Charset=UTF-8',
      'X-Auth-Local-Address': getLocalIp()
    }
  };
  return executeFetch(url, option);
}

export async function requestPut(url, body) {
  body = JSON.stringify(body);
  const option = {
    method: 'PUT',
    body,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      'content-Type': 'application/json;Charset=UTF-8',
      'X-Auth-Local-Address': getLocalIp()
    }
  };
  return executeFetch(url, option);
}

export async function requestDelete(url, body) {
  body = JSON.stringify(body);
  const option =
    body !== null
      ? {
        method: 'DELETE',
        body,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          'content-Type': 'application/json;Charset=UTF-8',
          'X-Auth-Local-Address': getLocalIp()
        }
      }
      : {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          'X-Auth-Local-Address': getLocalIp()
        }
      };
  return executeFetch(url, option);
}

export async function executeFetch(url, option) {
  Logger.log(url);
  return fetch(url, option)
    .then(res => {
      return res.json();
    })
    .then(json => {
      Logger.log(json);
      return json;
    })
    .catch(err => {
      Logger.log(err);
      return 'failedToFetch';
    });
}

export async function requestGetFile(url) {
  const option = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      'X-Auth-Local-Address': getLocalIp()
    }
  };
  return executeFileFetch(url, option);
}

// FormData의 boundary는 브라우저가 붙여야 하므로 Content-Type을 지정하지 않는다.
export async function requestPostFormFile(url, formData) {
  const option = {
    method: 'POST',
    body: formData,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      'X-Auth-Local-Address': getLocalIp()
    }
  };
  return executeFileFetch(url, option);
}

// 성공 시 파일 바이너리를, 실패/인증만료 시 JSON을 응답하는 API용 fetch
// 호출부가 기존 isValidResponse를 그대로 사용할 수 있도록 성공 응답에도 code를 넣어 반환한다.
export async function executeFileFetch(url, option) {
  Logger.log(url);

  let res;
  try {
    res = await fetch(url, option);
  } catch (err) {
    // 전송 자체가 실패한 경우만 로그아웃 대상으로 넘긴다.
    Logger.log(err);
    return 'failedToFetch';
  }

  try {
    const contentType = (res.headers.get('content-type') || '').toLowerCase();
    if (contentType.includes('application/json')) {
      const json = await res.json();
      Logger.log(json);
      // 이 엔드포인트들은 성공 시 파일을 준다. JSON 성공 응답은 구 계약이므로 실패로 취급한다.
      if (json && json.code === '0000') {
        return { code: '9999', message: '파일을 내려받지 못했습니다. 서버 응답 형식이 올바르지 않습니다.' };
      }
      return json;
    }

    // 파일 응답인지 명시적으로 확인한다. SSO/WAF가 200 + text/html 로그인 페이지를 줄 수 있다.
    const isFile =
      contentType.includes('spreadsheetml.sheet') || contentType.includes('application/octet-stream');
    if (res.ok && isFile) {
      return {
        code: '0000',
        blob: await res.blob(),
        fileName: parseAttachmentFileName(res.headers.get('content-disposition'))
      };
    }
    return {
      code: '9999',
      message: res.ok
        ? '파일을 내려받지 못했습니다. 서버 응답 형식이 올바르지 않습니다.'
        : `파일을 내려받지 못했습니다. (HTTP ${res.status})`
    };
  } catch (err) {
    // 본문 읽기 실패(스트림 중단 등)로 세션이 끊기지 않도록 로그아웃 대상에서 제외한다.
    Logger.log(err);
    return { code: '9999', message: '파일을 내려받지 못했습니다.' };
  }
}
